module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/en-奖杯组图.fb596376.png";